import { useEffect, useState } from 'react'
import { fetchDeliveryPolicy, type DeliveryPolicy } from '@/services/api'

const ATTEMPTS = 3
let cached: Promise<DeliveryPolicy> | null = null

const load = async (): Promise<DeliveryPolicy> => {
	for (let attempt = 1; ; attempt++) {
		try {
			return await fetchDeliveryPolicy()
		} catch (error) {
			if (attempt >= ATTEMPTS) throw error
			await new Promise((resolve) => setTimeout(resolve, attempt * 1000))
		}
	}
}

/**
 * The live delivery facts for the legal pages and product FAQ, shared across
 * components so a page loads them once. ``policy`` is null while loading.
 */
export const useDeliveryPolicy = () => {
	const [policy, setPolicy] = useState<DeliveryPolicy | null>(null)
	const [failed, setFailed] = useState(false)

	useEffect(() => {
		let active = true
		cached = cached || load()
		cached
			.then((result) => {
				if (active) setPolicy(result)
			})
			.catch((error) => {
				console.error('Failed to load delivery policy:', error)
				cached = null
				if (active) setFailed(true)
			})
		return () => {
			active = false
		}
	}, [])

	return { policy, failed }
}
